// Small helper to check if the current user has B2B privileges (can see pallet prices).
export const B2B_ROLES = ["buyer", "admin_broker", "sales_manager", "super_admin"];

export function isB2BUser(user) {
  return !!user && B2B_ROLES.includes(user.role);
}
